import { unixUTC } from "@/Utils/Date";

export const getRandomId = () => {
  return `${unixUTC()}_${Math.random().toString(36).substring(2, 15)}`;
};
